export default function Flag({ code, name, className = "w-6 h-5" }) {
  const c = (code || "").toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/w80/${c}.png`}
      srcSet={`https://flagcdn.com/w160/${c}.png 2x`}
      width="40"
      height="30"
      alt={name ? `${name} flag` : "flag"}
      loading="lazy"
      className={`${className} object-cover shadow-[0_1px_3px_rgba(0,0,0,0.15)] border border-slate-200`}
    />
  );
}
